import * as PIXI from "pixi.js";
import { config } from "./appConfig";
import { gameAssets, instances, scheduleAmbient } from "./gameUI";
import { getCurrentlyPlayingBg, playAmbient, playDisable, playMainBg, playMainBg1, playMainBg2, playMinus, playPlus, playPopupClose, playTabChange, sfxSound, toggleNonBgSounds } from "./soundManager";
import { tweenPulsate } from "./utility";
import { betHistory, setLanguage } from "./gameService";
import { formatBalance } from "./gameLogic";
import fruitDemo, { fruitData } from "./data";
import { isAppleMobileDevice } from "./appPixi";
import gsap from "gsap";

export class MenuPopUp {
    backgroundBlur = null;
    menuPopUp = null;
    currentSound = null;
    pointer = 0;
    tutorialNormal = [];
    tutorialSelected = [];
    language = 'eng'
    engScroll = false;
    rows = []
    leftScroll = false
    rightScroll = false;
    label = null

    settingsMenuActive = null;
    settingsButton = null;
    betHistoryActive = null;
    tutorialMenuActive = null;
    tutorialButton = null;
    betHistoryButton = null;
    maskGraphic = null;
    englishTutorialContainer = null;
    tagalogTutorialContainer = null;
    englishPages = [];
    tagalogPages = [];
    checkboxGroup = [];

    currentContainer = this.englishPages
    historyContainer = null;
    historyContent = ['Date', 'Time', 'Slice', 'Stake', 'Before\nBalance', 'After\nBalance', 'Win\nAmount', 'Status', 'Prize\nUpgrade']

    constructor() {
        this.menuPopUp = new PIXI.Container();
        this.menuPopUp.visible = false;
        this.historyContainer = new PIXI.Container();

        this.backgroundBlur = new PIXI.Graphics();
        this.backgroundBlur.beginFill(0, 0.3);
        this.backgroundBlur.drawRect(config.logicalWidth / 2 - 750, config.logicalHeight / 2 - 1600, 1500, 3500);
        this.backgroundBlur.endFill();
        this.backgroundBlur.interactive = false;
        this.menuPopUp.addChild(this.backgroundBlur);
        this.setupMenu();
        this.setupCloseButton();
        this.setupSettingsContent();
        this.enableSettingsMenu();
        this.setupBlueButtons(0, -85);
        this.setupTutorialMask();
        this.setupEnglishContent();
        this.setupTagalogContent();
        this.setupTutorialFooter();
        this.setupArrow();
        this.createBetHistory();
        this.betHistoryActive.addChild(this.historyContainer)
        this.applyHorizontalAndVerticalDrag()
        this.setupHistoryArrows();

        if (!fruitDemo.isDemo)
            this.setupCheatMode()
    }

    createCheckbox = (labelText, value, onChange) => {
        const container = new PIXI.Container();
        const boxSize = 80;

        const box = new PIXI.Graphics();
        box.lineStyle(3, 0x000000);
        box.beginFill(0xffffff);
        box.drawRect(0, 0, boxSize, boxSize);
        box.endFill();
        container.addChild(box);

        const checkmark = new PIXI.Graphics();
        checkmark.lineStyle(20, 0x00cc00, 1);
        checkmark.moveTo(18, 45);
        checkmark.lineTo(35, 60);
        checkmark.lineTo(62, 20);
        checkmark.visible = false;
        container.addChild(checkmark);

        const label = new PIXI.Text(labelText, {
            fontSize: 104,
            fill: 0xFFFFFF,
            fontWeight: 'bold'
        });
        label.x = boxSize + 15;
        label.y = -10;
        container.addChild(label);

        container.labelText = labelText;

        let checked = false;

        container.interactive = true;
        container.buttonMode = true;
        container.cursor = 'pointer';

        container.on('pointertap', () => {
            if (checked) {
                this.label = null
                container.setChecked(false);
                fruitData.showWin = false;
                fruitData.winName = null;

                gameAssets.roundPlusHitGraphic.interactive = true;
                gameAssets.roundMinusHitGraphic.interactive = true;
                gameAssets.roundPanelHitGraphic.interactive = true;

                instances.Meter.meterHolder[fruitData.totalRounds].visible = false;
                fruitData.totalRounds = fruitData.roundSettings[0];
                fruitData.roundPointer = 0;
                instances.Meter.meterHolder[fruitData.totalRounds].visible = true;
                instances.Meter.createMultipliers(fruitData.totalRounds);
                gameAssets.roundPanelText.text = fruitData.roundSettings[0];
                instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.totalRounds].length

                if (onChange) onChange(false, value);
            } else {
                this.checkboxGroup.forEach(cb => cb.setChecked(false));
                fruitData.showWin = true;

                gameAssets.roundPlusHitGraphic.interactive = false;
                gameAssets.roundMinusHitGraphic.interactive = false;
                gameAssets.roundPanelHitGraphic.interactive = false;

                container.setChecked(true);
                if (container.labelText == "Mega") {

                    if (this.label == 'Big' || this.label == 'Upgrade') {
                        instances.Meter.meterHolder[4].visible = false;
                    } else if (this.label == 'Ultra') {
                        instances.Meter.meterHolder[12].visible = false;
                    }

                    fruitData.winName = "megaWin";
                    fruitData.totalRounds = 8;
                    const currIndex = fruitData.roundSettings[fruitData.roundPointer];
                    instances.Meter.meterHolder[currIndex].visible = false;
                    instances.Meter.meterHolder[fruitData.totalRounds].visible = true;
                    instances.Meter.createMultipliers(fruitData.totalRounds);
                    gameAssets.roundPanelText.text = 8
                    instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.totalRounds].length

                    this.label = 'Mega'

                } else if (container.labelText == 'Big') {

                    if (this.label == 'Mega') {
                        instances.Meter.meterHolder[8].visible = false;
                    } else if (this.label == 'Ultra') {
                        instances.Meter.meterHolder[12].visible = false;
                    }

                    fruitData.winName = 'bigWin'
                    fruitData.totalRounds = 4;
                    const currIndex = fruitData.roundSettings[fruitData.roundPointer];
                    instances.Meter.meterHolder[currIndex].visible = false;
                    instances.Meter.meterHolder[fruitData.totalRounds].visible = true;
                    instances.Meter.createMultipliers(fruitData.totalRounds);
                    gameAssets.roundPanelText.text = 4
                    instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.totalRounds].length

                    this.label = 'Big'

                } else if (container.labelText == 'Ultra') {

                    if (this.label == 'Big' || this.label == 'Upgrade') {
                        instances.Meter.meterHolder[4].visible = false;
                    } else if (this.label == 'Mega') {
                        instances.Meter.meterHolder[8].visible = false;
                    }
                    fruitData.winName = 'ultraWin'

                    fruitData.totalRounds = 12;
                    const currIndex = fruitData.roundSettings[fruitData.roundPointer];
                    instances.Meter.meterHolder[currIndex].visible = false;
                    instances.Meter.meterHolder[fruitData.totalRounds].visible = true;
                    instances.Meter.createMultipliers(fruitData.totalRounds);
                    gameAssets.roundPanelText.text = 12
                    instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.totalRounds].length

                    this.label = 'Ultra'

                } else if (container.labelText == 'Upgrade') {
                    if (this.label == 'Mega') {
                        instances.Meter.meterHolder[8].visible = false;
                    } else if (this.label == 'Ultra') {
                        instances.Meter.meterHolder[12].visible = false;
                    }

                    fruitData.winName = 'prizeUpgrade';
                    fruitData.totalRounds = 4;
                    const currIndex = fruitData.roundSettings[fruitData.roundPointer];
                    instances.Meter.meterHolder[currIndex].visible = false;
                    instances.Meter.meterHolder[fruitData.totalRounds].visible = true;
                    instances.Meter.createMultipliers(fruitData.totalRounds);
                    gameAssets.roundPanelText.text = 4
                    instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.totalRounds].length

                    this.label = 'Upgrade';

                }
                if (onChange) onChange(true, value);
            }
        });

        container.setChecked = (val) => {
            checked = val;
            checkmark.visible = val;
        };

        container.isChecked = () => checked;

        this.checkboxGroup.push(container);

        return container;
    };

    setupCheatMode() {
        const majorCheckbox = this.createCheckbox("Mega", (val) => {
            console.log("Major:", val);
        });
        majorCheckbox.x = -220;
        majorCheckbox.y = 410;
        majorCheckbox.scale.set(0.45)
        majorCheckbox.visible = false;

        const minorCheckbox = this.createCheckbox("Big", (val) => {
            console.log("Minor:", val);
        });
        minorCheckbox.x = 35;
        minorCheckbox.y = 410;
        minorCheckbox.scale.set(0.45)
        minorCheckbox.visible = false;

        const grandCheckbox = this.createCheckbox("Ultra", (val) => {
            console.log("Grand:", val);
        });
        grandCheckbox.x = -460; //-430
        grandCheckbox.y = 410;
        grandCheckbox.scale.set(0.45)
        grandCheckbox.visible = false;

        const upgrade = this.createCheckbox('Upgrade', (val) => {
            console.log("upgrade");
        })
        upgrade.x = 230; //-430
        upgrade.y = 410;
        upgrade.scale.set(0.45)
        upgrade.visible = false;

        const winGraphic = new PIXI.Graphics();
        winGraphic.lineStyle(20, 0xffa500); // 8px orange border
        winGraphic.beginFill(0xffff00);    // Yellow fill
        winGraphic.drawRoundedRect(-400, 600, 800, 200, 30);
        winGraphic.endFill();
        winGraphic.interactive = true;
        winGraphic.buttonMode = true;
        winGraphic.cursor = 'pointer';
        winGraphic.y = 180;
        winGraphic.scale.set(0.35)

        const winLabel = new PIXI.Text("Show Win..", {
            fontSize: 90,
            fill: 0x000000,
            fontWeight: 'bold',
        });
        winLabel.anchor.set(0.5);
        winLabel.x = 0;
        winLabel.y = 700;
        winGraphic.addChild(winLabel);

        winGraphic.on('pointertap', () => {
            winGraphic.visible = false;
            fruitData.showWin = true;
            majorCheckbox.visible = true;
            minorCheckbox.visible = true;
            grandCheckbox.visible = true;
            upgrade.visible = true;
        });

        // Add everything to the stage
        // this.settingsMenuActive.addChild(
        //     winGraphic,
        //     majorCheckbox,
        //     minorCheckbox,
        //     grandCheckbox,
        //     upgrade
        // );

    }

    leftHorizontal(delta) {
        this.historyContainer.x = this.historyContainer.x - 1.5 * delta;
        if (this.historyContainer.x < -2090) {
            this.leftScroll = false;
        }
    }

    rightHorizontal(delta) {
        this.historyContainer.x = this.historyContainer.x + 1.5 * delta;
        if (this.historyContainer.x > 0) {
            this.rightScroll = false;
        }
    }

    vertical(delta) {
        this.historyRowContainer.y = this.historyRowContainer.y - 1.5 * delta;
        if (this.historyRowContainer.y < -430) {
            this.verticalScroll = false;
        }
    }

    setupHistoryArrows() {
        this.betArrow1 = new PIXI.Sprite(PIXI.Assets.get('scroll_arrow'));
        this.betArrow1.anchor.set(0.5);
        this.betArrow1.angle = -90;
        this.betArrow1.x = 500;
        this.betArrow1.scale.set(2);
        this.betArrow1.interactive = true;

        this.betArrow2 = new PIXI.Sprite(PIXI.Assets.get('scroll_arrow'));
        this.betArrow2.anchor.set(0.5);
        this.betArrow2.angle = 90
        this.betArrow2.x = -500;
        this.betArrow2.scale.set(2)
        this.betArrow2.interactive = true;

        this.betArrow3 = new PIXI.Sprite(PIXI.Assets.get('scroll_arrow'));
        this.betArrow3.anchor.set(0.5);
        this.betArrow3.y = 580;
        this.betArrow3.scale.set(2)
        this.betArrow3.interactive = true;

        this.betArrow1.on('pointerdown', (event) => {
            this.leftScroll = true;
            this.betArrow1.visible = false;
            this.betArrow2.visible = false;
            this.betArrow3.visible = false;

        })

        this.betArrow2.on('pointerdown', (event) => {
            this.rightScroll = true;
            this.betArrow1.visible = false;
            this.betArrow2.visible = false;
            this.betArrow3.visible = false;
        })

        this.betArrow3.on('pointerdown', (event) => {
            this.verticalScroll = true;
            this.betArrow1.visible = false;
            this.betArrow2.visible = false;
            this.betArrow3.visible = false;

        })

        gsap.timeline({ repeat: -1, yoyo: true })
            .to([this.betArrow1.scale, this.betArrow2.scale, this.betArrow3.scale], {
                x: 2.5,
                y: 2.5,
                duration: 0.5,
                ease: "power1.inOut"
            });

        this.betHistoryActive.addChild(this.betArrow1, this.betArrow2, this.betArrow3)
    }

    createBetHistory() {
        this.historyHeaderContainer = new PIXI.Container();
        this.historyHeaderContainer.x = 150;
        this.historyHeaderContainer.y = 235;

        this.mask2 = new PIXI.Sprite(PIXI.Assets.get('gameScreen'));
        this.mask2.anchor.set(0.5);
        this.mask2.scale.set(1.5, 0.1);
        this.mask2.alpha = 1
        this.mask2.x = 0
        this.mask2.y = -330

        const style = new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: "Arial",
            fontSize: 49,
            fontWeight: "bold",
            align: "center",
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 2,
            dropShadowAngle: Math.PI / 4,
            dropShadowDistance: 1,
            stroke: "#000000",
            strokeThickness: 0
        });

        let temp;
        let spacing = [-550, -280, 80, 415, 780, 1200, 1600, 1940, 2260]

        for (let i = 0; i < this.historyContent.length; i++) {
            const label = this.historyContent[i];

            const text = new PIXI.Text(label, style);
            text.anchor.set(0.5);

            text.x = spacing[i]

            if (i == 8 || i == 6 || i == 5 || i == 4) text.y = -568
            else if (i == 9) text.y = -575
            else text.y = -540;
            temp = text.x;

            this.historyHeaderContainer.addChild(text);
        }

        this.mask1 = new PIXI.Sprite(PIXI.Assets.get('gameScreen'));
        this.mask1.anchor.set(0.5);
        this.mask1.scale.set(1.5, 0.72);
        this.mask1.alpha = 1
        this.mask1.x = 0
        this.mask1.y = 145

        this.historyRowContainer = new PIXI.Container();
        this.historyContainer.addChild(this.historyRowContainer)
        const width = this.historyHeaderContainer.width;

        for (let i = 0; i < 10; i++) {
            this.rows[i] = new PIXI.Sprite(PIXI.Assets.get('history_row'));
            this.rows[i].anchor.set(0, 0.5);
            if (i == 0) this.rows[i].y = -210;
            else this.rows[i].y = this.rows[i - 1].y + 125;
            this.rows[i].x = -475;
            const r_width = this.rows[i].width;
            const scale = width / r_width;

            this.rows[i].scale.set(scale * 1.02, 1);

            this.historyRowContainer.addChild(this.rows[i]);
        }

        this.betHistoryActive.addChild(this.mask2, this.mask1);
        this.historyContainer.addChild(this.historyHeaderContainer);
        this.historyHeaderContainer.mask = this.mask2;
        this.historyRowContainer.mask = this.mask1

    }

    setActiveLanguage = (lang) => {
        if (lang === "en") {
            gameAssets.langEnglishNonSelect.visible = false;
            gameAssets.langEnglishSelect.visible = true;
            gameAssets.langTagalogNonSelect.visible = true;
            gameAssets.langTagalogSelect.visible = false;
            gameAssets.currentActiveLanguage = gameAssets.langEnglishSelect;
            this.currentContainer = this.englishPages;
            this.language = 'eng'

        } else if (lang === "tl") {
            gameAssets.langEnglishNonSelect.visible = true;
            gameAssets.langEnglishSelect.visible = false;
            gameAssets.langTagalogNonSelect.visible = false;
            gameAssets.langTagalogSelect.visible = true;
            gameAssets.currentActiveLanguage = gameAssets.langTagalogSelect;
            this.currentContainer = this.tagalogPages;
            this.language = 'tag'
        }
    };

    setupBlueButtons(x, y) {
        const toggle1Container = new PIXI.Container();
        const toggle2Container = new PIXI.Container();

        gameAssets.langEnglishSelect = new PIXI.Sprite(PIXI.Assets.get('lang_english_select'))
        gameAssets.langEnglishNonSelect = new PIXI.Sprite(PIXI.Assets.get('lang_english_nonselect'))

        gameAssets.langTagalogSelect = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog_select'))
        gameAssets.langTagalogNonSelect = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog_nonselect'))

        gameAssets.currentActiveLanguage = gameAssets.langEnglishSelect

        toggle1Container.y = y + 160
        toggle1Container.x = x
        toggle1Container.pivot.x = toggle1Container.width / 2
        toggle1Container.scale.set(1)
        toggle2Container.scale.set(1)

        gameAssets.langEnglishNonSelect.visible = false
        gameAssets.langEnglishSelect.visible = true

        gameAssets.langEnglishSelect.x = -gameAssets.langEnglishSelect.width / 2
        gameAssets.langEnglishNonSelect.x = -gameAssets.langEnglishNonSelect.width / 2

        toggle1Container.interactive = true;
        toggle1Container.buttonMode = true;
        toggle1Container.cursor = 'pointer'

        toggle1Container.addChild(gameAssets.langEnglishSelect)
        toggle1Container.addChild(gameAssets.langEnglishNonSelect)

        toggle2Container.y = toggle1Container.y + 165
        toggle2Container.x = x
        toggle2Container.pivot.x = toggle2Container.width / 2

        gameAssets.langTagalogNonSelect.visible = true
        gameAssets.langTagalogSelect.visible = false

        gameAssets.langTagalogSelect.x = -gameAssets.langTagalogSelect.width / 2;
        gameAssets.langTagalogNonSelect.x = -gameAssets.langTagalogNonSelect.width / 2;

        toggle2Container.interactive = true
        toggle2Container.buttonMode = true
        toggle2Container.cursor = 'pointer'

        toggle2Container.addChild(gameAssets.langTagalogSelect)
        toggle2Container.addChild(gameAssets.langTagalogNonSelect)

        toggle2Container.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

                if (gameAssets.currentActiveLanguage === gameAssets.langTagalogSelect) return;

                gameAssets.langTagalogNonSelect.visible = false;
                gameAssets.langTagalogSelect.visible = true;
                gameAssets.currentActiveLanguage = gameAssets.langTagalogSelect;
                gameAssets.langEnglishNonSelect.visible = true;
                gameAssets.langEnglishSelect.visible = false;
                this.tagalogTutorialContainer.visible = true;
                this.englishTutorialContainer.visible = false;
                this.currentContainer = this.tagalogPages
                this.pointer = 0;
                this.language = 'tag'
                this.tagPage11Container.y = this.engPage11Container.y = 0;

                this.tagalogPages.map((value, index) => {
                    if (index == 0) value.visible = true;
                    else value.visible = false;
                })
                this.updateTutorialIndicator()
                this.arrow.visible = false;
                setLanguage('tl')

            }
        })

        toggle1Container.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

                if (gameAssets.currentActiveLanguage === gameAssets.langEnglishSelect) return;
                gameAssets.langEnglishNonSelect.visible = false;
                gameAssets.langEnglishSelect.visible = true;
                gameAssets.currentActiveLanguage = gameAssets.langEnglishSelect;
                gameAssets.langTagalogNonSelect.visible = true;
                gameAssets.langTagalogSelect.visible = false;
                this.tagalogTutorialContainer.visible = false;
                this.englishTutorialContainer.visible = true;
                this.currentContainer = this.englishPages;
                this.pointer = 0;
                this.language = 'eng'
                this.tagPage11Container.y = this.engPage11Container.y = 0;

                this.englishPages.map((value, index) => {
                    if (index == 0) value.visible = true;
                    else value.visible = false;
                })
                this.updateTutorialIndicator()
                this.arrow.visible = false;
                setLanguage('en')

            }
        })

        this.settingsMenuActive.addChild(toggle1Container, toggle2Container)

    }

    setupArrow() {
        this.arrow = new PIXI.Sprite(PIXI.Assets.get('scroll_arrow'));
        this.arrow.anchor.set(0.5);
        this.arrow.position.set(0, 560);
        this.arrow.scale.set(1.9);
        this.arrow.interactive = true;
        this.arrow.visible = false;

        this.arrow.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (this.language == 'eng') {
                    if (fruitData.showAutoAndTurbo) this.engScroll = true;
                } else {
                    if (this.pointer == 10) {
                        if (fruitData.showAutoAndTurbo) this.tagScroll = true;
                    } else {
                        this.tagScroll = true;
                    }
                }
                this.arrow.visible = false;
            }
        });

        tweenPulsate(this.arrow, 0.3, 2.35)

        this.tutorialMenuActive.addChild(this.arrow)
    }

    scroll(delta) {
        if (this.language == 'eng') {
            if (this.pointer == 10 && fruitData.showAutoAndTurbo) {
                this.engPage11Container.y = this.engPage11Container.y - 1.5 * delta;
                if (this.engPage11Container.y < -3550) this.engScroll = false;
            } else {
                this.engScroll = false;
                this.engPage11Container.y = 0;
            }
        } else {
            if (this.pointer == 10) {
                if (fruitData.showAutoAndTurbo) {
                    this.tagPage11Container.y = this.tagPage11Container.y - 1.5 * delta;
                    if (this.tagPage11Container.y < -4025) this.tagScroll = false;
                } else {
                    this.tagScroll = false;
                    this.tagPage11Container.y = 0;
                }
            } else {
                this.tagPage5Container.y = this.tagPage5Container.y - 1.5 * delta;
                if (this.tagPage5Container.y < -670) this.tagScroll = false;
            }

        }
    }

    applyHorizontalAndVerticalDrag() {

        {
            let dragging = false;
            let startX = 0;
            let containerStartX = 0;

            const minX = -2100;
            const maxX = 0;

            this.historyContainer.interactive = true;
            this.historyContainer.cursor = "grab";

            this.historyContainer
                .on("pointerdown", (event) => {
                    dragging = true;
                    startX = event.data.global.x;
                    containerStartX = this.historyContainer.x;
                })
                .on("pointermove", (event) => {
                    if (!dragging) return;
                    const currentX = event.data.global.x;
                    const delta = currentX - startX;

                    this.betArrow1.visible = true;
                    this.betArrow2.visible = true;
                    this.betArrow3.visible = true;
                    this.leftScroll = this.rightScroll = this.verticalScroll = false;

                    this.historyContainer.x = Math.max(minX, Math.min(maxX, containerStartX + delta));
                })
                .on("pointerup", () => {
                    dragging = false;
                })
                .on("pointerupoutside", () => {
                    dragging = false;
                });
        }

        {
            this.historyRowContainer.interactive = true;
            this.historyRowContainer.cursor = 'grab';

            let dragging = false;
            let startY = 0;
            let containerStartY = 0;

            const MIN_Y = -425;  // how far up the container can go
            const MAX_Y = 0;     // how far down (usually 0 = starting pos)

            this.historyRowContainer
                .on('pointerdown', (event) => {
                    dragging = true;
                    startY = event.data.global.y;
                    containerStartY = this.historyRowContainer.y;
                })
                .on('pointermove', (event) => {
                    if (!dragging) return;

                    const currentY = event.data.global.y;
                    const delta = currentY - startY;

                    let newY = containerStartY + delta;

                    if (newY < MIN_Y) newY = MIN_Y;
                    if (newY > MAX_Y) newY = MAX_Y;

                    this.betArrow1.visible = true;
                    this.betArrow2.visible = true;
                    this.betArrow3.visible = true;
                    this.leftScroll = this.rightScroll = this.verticalScroll = false;

                    this.historyRowContainer.y = newY;
                })
                .on('pointerup', () => {
                    dragging = false;
                })
                .on('pointerupoutside', () => {
                    dragging = false;
                });
        }

    }

    populateRows() {
        const style = new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: "Arial",
            fontSize: 11,
            fontWeight: "bold",
            align: "center",
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 2,
            dropShadowAngle: Math.PI / 4,
            dropShadowDistance: 1,
            stroke: "#000000",
            strokeThickness: 0
        });

        const scaleOffset = 155;

        fruitData.betHist.map((value, index) => {
            const { bet_amount, result, date, time, car_direction, beforebalance, afterbalance, winning_amount, prize_upgrade } = value;
            this.rows[index].removeChildren();
            const directionString = Array.isArray(car_direction) ? car_direction.join(',') : '';
            const before = formatBalance(beforebalance, 2)
            const after = formatBalance(afterbalance, 2)
            const newWin = formatBalance(winning_amount, 2)

            const text1 = new PIXI.Text(date, style);
            const text2 = new PIXI.Text(time, style);
            const text4 = new PIXI.Text(directionString, style);
            const text5 = new PIXI.Text(bet_amount, style);
            const text6 = new PIXI.Text(before, style);
            const text7 = new PIXI.Text(after, style);
            const text8 = new PIXI.Text(newWin, style);
            const text9 = new PIXI.Text(result, style);
            const text10 = new PIXI.Text(prize_upgrade, style);

            text10.anchor.set(0.5);
            text9.anchor.set(0.5);
            text8.anchor.set(0.5);
            text7.anchor.set(0.5);
            text6.anchor.set(0.5);
            text5.anchor.set(0.5);
            text4.anchor.set(0.5);
            text2.anchor.set(0.5);
            text1.anchor.set(0.5);

            if (text4.width >= scaleOffset) {
                const scale = scaleOffset / text4.width
                text4.scale.set(scale, 2)
            } else {
                text4.scale.set(1, 2);
            }

            text1.scale.set(1, 2);
            text2.scale.set(1, 2);

            text5.scale.set(1, 2);
            text6.scale.set(0.9, 2);

            text7.scale.set(0.9, 2);
            text8.scale.set(1, 2);
            text9.scale.set(1, 2);
            text10.scale.set(1, 2);

            text1.x = 31;
            text2.x = 113
            text4.x = 228;
            text5.x = 333;
            text6.x = 450;
            text7.x = 585;
            text8.x = 715
            text9.x = 825
            text10.x = 930;

            this.rows[index].addChild(text1, text2, text4, text5, text6, text7, text8, text9, text10);
        });
    }

    setupTutorialFooter() {
        const rightNormal = new PIXI.Sprite(PIXI.Assets.get('right_b_normal'));
        rightNormal.anchor.set(0.5);
        rightNormal.interactive = true;
        rightNormal.cursor = 'pointer';
        rightNormal.position.set(500, 695);

        rightNormal.on('pointerover', () => {
            rightNormal.texture = PIXI.Assets.get('right_b_selected')
        })

        rightNormal.on('pointerout', () => {
            rightNormal.texture = PIXI.Assets.get('right_b_normal')
        })

        rightNormal.on('pointerupoutside', () => {
            rightNormal.texture = PIXI.Assets.get('right_b_normal')
        })

        rightNormal.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (this.pointer < this.englishPages.length - 1) {
                    let current = this.currentContainer[this.pointer];
                    current.visible = false;
                    this.pointer++;
                    current = this.currentContainer[this.pointer];
                    current.visible = true;
                    this.updateTutorialIndicator()
                    playPlus(true);
                    this.engScroll = false;

                    if (
                        (this.language == 'eng' && this.pointer == 10 && fruitData.showAutoAndTurbo) ||
                        (this.language == 'tag' && (
                            this.pointer == 4 ||
                            (this.pointer == 10 && fruitData.showAutoAndTurbo)
                        ))
                    ) {
                        this.arrow.visible = true;
                    } else {
                        this.arrow.visible = false;
                    }
                } else {
                    playDisable(true);
                }
            }
        })


        for (let j = 0; j < this.englishPages.length; j++) {
            this.tutorialNormal[j] = new PIXI.Sprite(PIXI.Assets.get('tutorial_b_normal'));
            this.tutorialNormal[j].anchor.set(0.5);
            this.tutorialNormal[j].position.set(j == 0 ? -405 : this.tutorialNormal[j - 1].x + 75, 695);
            this.tutorialNormal[j].scale.set(0.8);

            this.tutorialSelected[j] = new PIXI.Sprite(PIXI.Assets.get('tutorial_b_selected'));
            this.tutorialSelected[j].anchor.set(0.5);
            this.tutorialSelected[j].position.set(0, 0);
            this.tutorialSelected[j].visible = false;

            this.tutorialNormal[j].addChild(this.tutorialSelected[j]);
        }

        this.updateTutorialIndicator()


        const leftNormal = new PIXI.Sprite(PIXI.Assets.get('left_b_normal'));
        leftNormal.anchor.set(0.5);
        leftNormal.position.set(-485, 695);
        leftNormal.scale.set(1);
        leftNormal.interactive = true;
        leftNormal.cursor = 'pointer';
        leftNormal.on('pointerover', () => { leftNormal.texture = PIXI.Assets.get('left_b_selected'); });
        leftNormal.on('pointerout', () => { leftNormal.texture = PIXI.Assets.get('left_b_normal'); });

        this.tutorialMenuActive.addChild(leftNormal, ...this.tutorialNormal, rightNormal);

        leftNormal.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (this.pointer > 0) {
                    let current = this.currentContainer[this.pointer];
                    current.visible = false;
                    this.pointer--;
                    current = this.currentContainer[this.pointer];
                    current.visible = true;
                    this.updateTutorialIndicator()
                    playMinus(true);
                    this.engScroll = false;
                    if ((this.language == 'eng' && this.pointer == 10 && fruitData.showAutoAndTurbo) ||
                        (this.language == 'tag' && this.pointer == 4)) {
                        this.arrow.visible = true;
                    } else {
                        this.arrow.visible = false;
                    }
                } else {
                    playDisable(true);
                }
            }
        });
    }

    updateTutorialIndicator() {
        for (let j = 0; j < this.englishPages.length; j++) {
            this.tutorialSelected[j].visible = this.pointer === j;
        }
    }

    setupEnglishContent() {
        this.englishTutorialContainer = new PIXI.Container();
        this.englishTutorialContainer.mask = this.maskGraphic;
        this.englishTutorialContainer.visible = false;
        this.tutorialMenuActive.addChild(this.englishTutorialContainer);

        const data = PIXI.Assets.get('textEng');

        const whiteStyle = new PIXI.TextStyle({
            fill: "#FFFFFF",
            fontFamily: "notoSans",
            fontSize: 60,
            fontWeight: "500",
            align: "center",
        });

        const yellowStyle = new PIXI.TextStyle({
            fill: "#FFF000",
            fontFamily: "notoSans",
            fontSize: 60,
            fontWeight: "700",
            align: "center",
        });

        this.drawStartingPages(data, whiteStyle, yellowStyle)

    }


    setupTagalogContent() {
        this.tagalogTutorialContainer = new PIXI.Container();
        this.tagalogTutorialContainer.mask = this.maskGraphic;
        this.tutorialMenuActive.addChild(this.tagalogTutorialContainer);

        this.drawtagalogPages();
    }

    drawtagalogPages() {
        this.tagPage1Container = new PIXI.Container();
        this.tagPage2Container = new PIXI.Container();
        this.tagPage3Container = new PIXI.Container();
        this.tagPage4Container = new PIXI.Container();
        this.tagPage5Container = new PIXI.Container();
        this.tagPage6Container = new PIXI.Container();
        this.tagPage7Container = new PIXI.Container();
        this.tagPage8Container = new PIXI.Container();
        this.tagPage9Container = new PIXI.Container();
        this.tagPage10Container = new PIXI.Container();
        this.tagPage11Container = new PIXI.Container();
        this.tagPage12Container = new PIXI.Container();

        for (let i = 1; i <= 12; i++) {
            this.tagalogPages.push(this[`tagPage${i}Container`]);
        }

        {
            const text1 = new PIXI.Text('Maghiwa ng Prutas', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P1'));
            img1.anchor.set(0.5);
            img1.scale.set(0.95)
            img1.position.set(0, -35)

            const text2 = new PIXI.Text('Mamili ng prutas para', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-105, 200);

            const text3 = new PIXI.Text('HIWAIN.', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(290, 200);

            const text4 = new PIXI.Text('Ang bawat', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(-300, 305);

            const text5 = new PIXI.Text('Prutas ay mayroong 50%', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(108, 305);

            const text6 = new PIXI.Text('pagkakataon', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(-250, 365);

            const text7 = new PIXI.Text('na matagumpay na', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(120, 365);

            const text8 = new PIXI.Text("mahiwa, ito'y magpapakita ng", {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(-90, 425);

            const text9 = new PIXI.Text("Barya", {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5)
            text9.position.set(320, 425);

            const text10 = new PIXI.Text("kung tama ang pili mo.", {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5)
            text10.position.set(0, 485);

            this.tagPage1Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10)
        }

        {
            const text1 = new PIXI.Text('Manalo ng mga Premyo', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 70,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P2'));
            img1.anchor.set(0.5);
            img1.scale.set(0.95)
            img1.position.set(0, -35);

            const text2 = new PIXI.Text('Ang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-370, 225);

            const text3 = new PIXI.Text('PREMYO', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(-205, 225);

            const text4 = new PIXI.Text('ay ibinibigay ay batay', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(175, 225);

            const text5 = new PIXI.Text('sa', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(-265, 280);

            const text6 = new PIXI.Text('kabuuang bilang ng', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(25, 280);

            const text7 = new PIXI.Text('matagumpay na HIWA', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(-150, 337);

            const text8 = new PIXI.Text('pagkatapos', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(280, 337);

            const text9 = new PIXI.Text('makumpleto ang lahat ng rounds.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5)
            text9.position.set(0, 395);

            this.tagPage2Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9)
        }

        {
            const text1 = new PIXI.Text('Pagtaas ng Premyo!', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 70,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -340);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P3_A'));
            img1.anchor.set(0.5);
            img1.position.set(0, -220);

            const text2 = new PIXI.Text('hanggang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 48,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(0, -105);

            const img2 = new PIXI.Sprite(PIXI.Assets.get('EN_P3_B'));
            img2.anchor.set(0.5);
            img2.position.set(0, 15);

            const text3 = new PIXI.Text('Pagkatapos makumpleto ang lahat ng\n slices, ang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "left",
                lineHeight: 57.6
            });
            text3.anchor.set(0.5)
            text3.position.set(0, 165);

            const text4 = new PIXI.Text('pinakamababang antas ng', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "left",
                lineHeight: 57.6
            });
            text4.anchor.set(0.5)
            text4.position.set(128, 195);

            const text5 = new PIXI.Text('PREMYO', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "left",
                lineHeight: 57.6
            });
            text5.anchor.set(0.5)
            text5.position.set(-255, 255);

            const text6 = new PIXI.Text('ay may pagkakataong', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "left",
                lineHeight: 57.6
            });
            text6.anchor.set(0.5)
            text6.position.set(115, 255);

            const text7 = new PIXI.Text('maging', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "left",
                lineHeight: 57.6
            });
            text7.anchor.set(0.5)
            text7.position.set(-315, 310);

            const text8 = new PIXI.Text('pinakamataas na antas ng', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 46 : 49,
                fontWeight: "600",
                align: "left",
                lineHeight: 58.8
            });
            text8.anchor.set(0.5)
            text8.position.set(100, 310);

            const text9 = new PIXI.Text('PREMYO', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "left",
                lineHeight: 57.6
            });
            text9.anchor.set(0.5)
            text9.position.set(-330, 370);

            const text10 = new PIXI.Text('para sa mga napiling slices.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "left",
                lineHeight: 57.6
            });
            text10.anchor.set(0.5)
            text10.position.set(100, 370);

            //Pagkatapos makumpleto ang

            this.tagPage3Container.addChild(text1, img1, text2, img2, text3, text4, text5, text6, text7, text8, text9, text10)
        }

        {
            const text1 = new PIXI.Text('Paano Manalo?', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 70,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P4'));
            img1.anchor.set(0.5);
            img1.position.set(0, -90);

            const text2 = new PIXI.Text('Ang mga manlalaro ay', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-160, 150);

            const text3 = new PIXI.Text('kailanagang', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(280, 150);

            const text4 = new PIXI.Text('matagumpay na MAHIWA ang', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(0, 205);

            const text5 = new PIXI.Text('prutas,', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(0, 260);

            const text6 = new PIXI.Text('Mas maraming prutas ang matagumpay', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(0, 315);

            const text7 = new PIXI.Text('na NAHIWA mas mataas ang premyong', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 44 : 47,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(0, 370);

            const text8 = new PIXI.Text('matatanggap.', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 44 : 47,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(0, 425);

            this.tagPage4Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8)
        }

        {
            const text1 = new PIXI.Text('Bar ng Pag-Usad', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 70,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -355);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P5'));
            img1.anchor.set(0.5);
            img1.position.set(265, 150);

            const text2 = new PIXI.Text('Pwedeng Mapanalunan', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 46,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-200, -105);

            const text3 = new PIXI.Text('Bawat matagumpay na\npaghiwa ay nagtutulak\nsa manlalaro na\numusad pataas sa metro\nng premyo', {
                fill: "#00FF00",
                fontFamily: "notoSans",
                fontSize: 46,
                fontWeight: "600",
                align: "left",
                lineHeight: 55.2
            });
            text3.anchor.set(0.5)
            text3.position.set(-125, 370);

            const text4 = new PIXI.Text('Ang kasalukuyang\npremyo ay\nipinapakita sa ilalim\nng metro ng premyo', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 46,
                fontWeight: "600",
                align: "left",
                lineHeight: 55.2
            });
            text4.anchor.set(0.5)
            text4.position.set(-160, 670);

            const text5 = new PIXI.Text('Subaybayan ang iyong\nprogreso tungo sa\npanalong premyo. Mas\nmaraming matagumpay\nna paghiwa ay\nmagdadagdag sa\nposibleng premyo.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 46,
                fontWeight: "600",
                align: "left",
                lineHeight: 55.2
            });
            text5.anchor.set(0.5)
            text5.position.set(-115, 1010);

            this.tagPage5Container.addChild(text1, img1, text2, text3, text4, text5)
        }

        {
            const text1 = new PIXI.Text('Ang Pulang Stopwatch', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 70,
                fontWeight: "900",
                align: "center",
                lineHeight: 84
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P6'));
            img1.anchor.set(0.5);
            img1.position.set(0, -55);

            const text2 = new PIXI.Text('Ipinapakita ng tagapagpahiwatig na', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "600",
                align: "center",
                lineHeight: 60
            });
            text2.anchor.set(0.5)
            text2.position.set(0, 205);

            const text3 = new PIXI.Text('ang kabuuang natitirang mga hiwa', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "600",
                align: "center",
                lineHeight: 60
            });
            text3.anchor.set(0.5)
            text3.position.set(0, 260);

            const text4 = new PIXI.Text('hanggang matapos ang laro.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "600",
                align: "center",
                lineHeight: 60
            });
            text4.anchor.set(0.5)
            text4.position.set(0, 315);

            this.tagPage6Container.addChild(text1, img1, text2, text3, text4)
        }

        {
            const text1 = new PIXI.Text('Ang Pabilog na Orasan', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 70,
                fontWeight: "900",
                align: "center",
                lineHeight: 84
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P7'));
            img1.anchor.set(0.5);
            img1.position.set(0, 10);

            const text2 = new PIXI.Text('Mayroon kang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 43 : 46,
                fontWeight: "600",
                align: "center",
                lineHeight: 55.2
            });
            text2.anchor.set(0.5)
            text2.position.set(-310, 315);

            const text3 = new PIXI.Text('10 segundo', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 43 : 46,
                fontWeight: "600",
                align: "center",
                lineHeight: 55.2
            });
            text3.anchor.set(0.5)
            text3.position.set(-10, 315);

            const text4 = new PIXI.Text('upang magawa', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 43 : 46,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(303, 315);

            const text5 = new PIXI.Text('mo ang hiwa! Hindi mo nagawa!, at ang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 43 : 46,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(0, 370);

            const text6 = new PIXI.Text('laro ay, maghahati ng ibat-ibang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 43 : 46,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(0, 425);

            const text7 = new PIXI.Text('prutas para sa iyo!', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 43 : 46,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(0, 480);

            this.tagPage7Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7)

        }

        {
            const text1 = new PIXI.Text('Naku po! Natalo ako.', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 70,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P8'));
            img1.anchor.set(0.5);
            img1.position.set(0, -15);

            const text2 = new PIXI.Text('Ang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-395, 240);

            const text3 = new PIXI.Text('PAGHIWA', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(-220, 240);

            const text4 = new PIXI.Text('ng', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(-60, 240);

            const text5 = new PIXI.Text('maling prutas', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(155, 240);

            const text6 = new PIXI.Text('ay', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(360, 240);

            const text7 = new PIXI.Text('magpapakita ng', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(-235, 295);

            const text8 = new PIXI.Text('BOMBA', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(65, 300);

            const text9 = new PIXI.Text('na hindi', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5)
            text9.position.set(265, 300);

            const text10 = new PIXI.Text('ka pinauusad pataas sa Metro', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5)
            text10.position.set(-40, 350);

            const text11 = new PIXI.Text('ng', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text11.anchor.set(0.5)
            text11.position.set(-140, 405);

            const text12 = new PIXI.Text('Premyo.', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text12.anchor.set(0.5)
            text12.position.set(0, 410);


            this.tagPage8Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11, text12)
        }

        {
            const text1 = new PIXI.Text('Ang Puso, Ang Iyong Buhay', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 63,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P9'));
            img1.anchor.set(0.5);
            img1.position.set(0, -100);

            const text2 = new PIXI.Text('Mag-ingat!', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 46 : 49,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-335, 150);

            const text3 = new PIXI.Text('Piliin ang tamang prutas na', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 46 : 49,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(138, 150);

            const text4 = new PIXI.Text('hihiwain-', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 48,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(-355, 215);

            const text5 = new PIXI.Text('ang paghiwa sa maling prutas', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(115, 215);

            const text6 = new PIXI.Text('ay maaring magsimula ng bomba.Kapag', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 44 : 47,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(-2, 276);

            const text7 = new PIXI.Text('tinamaan mo ang bomba, ay,', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(-145, 336);

            const text8 = new PIXI.Text('mawawalan', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(320, 336);

            const text9 = new PIXI.Text('ka ng 1 puso', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
                lineHeight: isAppleMobileDevice() ? 49.2 : 52.8
            });
            text9.anchor.set(0.5)
            text9.position.set(-328, 393);

            const text10 = new PIXI.Text('mula sa iyong puso ng buhay.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
                lineHeight: isAppleMobileDevice() ? 49.2 : 52.8
            });
            text10.anchor.set(0.5)
            text10.position.set(140, 393);

            const text11 = new PIXI.Text('Maubos mo ang lahat ng puso... at ito ang\nkatapusan ng laro', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
                lineHeight: isAppleMobileDevice() ? 50.4 : 54
            });
            text11.anchor.set(0.5)
            text11.position.set(0, 477);

            //Maubos mo ang lahat ng puso

            this.tagPage9Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11)
        }

        {
            const text1 = new PIXI.Text('Awtomatikong Pagtatapos', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P12'));
            img1.anchor.set(0.5);
            img1.position.set(0, 95);

            const text2 = new PIXI.Text('Ang laro ay awtomatikong magtatapos\nkapag nagamit mo na lahat ang\niyong hiniwa.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 49,
                fontWeight: "600",
                align: "center",
                lineHeight: isAppleMobileDevice() ? 56.4 : 58.8,
            });
            text2.anchor.set(0.5)
            text2.position.set(0, 255);

            const text3 = new PIXI.Text('Ang mga hiwa ay mababawasan ng 1 sa\nbawat matagumpay o nabigong\npaghiwa.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 49,
                fontWeight: "600",
                align: "center",
                lineHeight: isAppleMobileDevice() ? 56.4 : 58.8,
            });
            text3.anchor.set(0.5)
            text3.position.set(0, 445);

            this.tagPage10Container.addChild(text1, img1, text2, text3)
        }

        {
            const childrenToAdd = [];

            const text1 = new PIXI.Text('Gampanin ng Laro', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -340);
            childrenToAdd.push(text1);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_A'));
            img1.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img1.position.set(-345, -145);
                img1.scale.set(1);
            } else {
                img1.position.set(-345, -200);
                img1.scale.set(0.55);
            }
            childrenToAdd.push(img1);

            const text2 = new PIXI.Text('Pindutan sa paglaro', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 49,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(25, fruitData.showAutoAndTurbo ? -140 : -200);
            childrenToAdd.push(text2);

            const img4 = new PIXI.Sprite(PIXI.Assets.get('menuNormal'));
            img4.anchor.set(0.5);
            img4.scale.set(fruitData.showAutoAndTurbo ? 1.15 : 0.85);
            img4.position.set(-345, fruitData.showAutoAndTurbo ? 460 : -50);
            childrenToAdd.push(img4);

            const text5 = new PIXI.Text('Pagbukas ng settings\nng laro', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 45,
                fontWeight: "600",
                align: "left",
            });
            text5.anchor.set(0.5)
            text5.position.set(fruitData.showAutoAndTurbo ? 2 : 18, fruitData.showAutoAndTurbo ? 460 : -60);
            childrenToAdd.push(text5);

            const imgg6 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_b'));
            imgg6.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                imgg6.position.set(0, 725);
                imgg6.scale.set(1);
            } else {
                imgg6.position.set(-120, 160);
                imgg6.scale.set(0.8);
            }
            childrenToAdd.push(imgg6);

            const imgg6Text = new PIXI.Text('Baguhin ang pagtaya\nsa Bet/Slices', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 40,
                fontWeight: "600",
                align: "left",
                lineHeight: 48
            });
            imgg6Text.anchor.set(0.5)
            imgg6Text.position.set(190, 10);
            imgg6.addChild(imgg6Text)

            const imgg7 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_c'));
            imgg7.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                imgg7.position.set(-200, 1110);
                imgg7.scale.set(1);
            } else {
                imgg7.position.set(-310, 420);
                imgg7.scale.set(0.6);
            }
            childrenToAdd.push(imgg7);

            const imgg7Text = new PIXI.Text('Madaling\nPagtaya!', {
                fill: "#60004C",
                fontFamily: "notoSans",
                fontSize: 44,
                fontWeight: "600",
                align: "left",
                lineHeight: 52.8
            });
            imgg7Text.anchor.set(0.5);
            imgg7Text.position.set(0, -90);
            imgg7.addChild(imgg7Text);

            const imgText7 = new PIXI.Text('Baguhin ang pagtaya sa\nBet/Slices sa pamamagitan\nng pagpindot sa gitna.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "left",
                lineHeight: 45.6
            });
            imgText7.anchor.set(0.5)
            imgText7.position.set(fruitData.showAutoAndTurbo ? 220 : 80, fruitData.showAutoAndTurbo ? 1020 : 380);
            childrenToAdd.push(imgText7);

            if (fruitData.showAutoAndTurbo) {

                const img2 = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
                img2.anchor.set(0.5);
                img2.scale.set(1.15);
                img2.position.set(-345, 80);
                childrenToAdd.push(img2);

                const text3 = new PIXI.Text('Pagbukas o pagsasara ng\nawtomatikong paglaro autoplay', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 43 : 45,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 54
                });
                text3.anchor.set(0.5)
                text3.position.set(125, 70);
                childrenToAdd.push(text3);

                const img3 = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
                img3.anchor.set(0.5);
                img3.scale.set(1.15);
                img3.position.set(-345, 280);
                childrenToAdd.push(img3);

                const text4 = new PIXI.Text('Pagbukas o pagsasara\nng turbo', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 45,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 54
                });
                text4.anchor.set(0.5)
                text4.position.set(15, 275);
                childrenToAdd.push(text4);

                const text6 = new PIXI.Text('Awtomatikong Paglalaro', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: 60,
                    fontWeight: "600",
                    align: "left",
                });
                text6.anchor.set(0.5)
                text6.position.set(0, 1370);
                childrenToAdd.push(text6);

                const img6 = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
                img6.anchor.set(0.5);
                img6.scale.set(1.15);
                img6.position.set(0, 1525);
                childrenToAdd.push(img6);

                const text7 = new PIXI.Text('Ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text7.anchor.set(0.5)
                text7.position.set(-380, 1700);

                const text8 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text8.anchor.set(0.5)
                text8.position.set(-200, 1700);

                const text9 = new PIXI.Text('ay awtomatikong', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text9.anchor.set(0.5)
                text9.position.set(140, 1700);

                const text10 = new PIXI.Text('sinisimulan ang bawat hiwa gamit \nang parehong sapalarang bilang\nsa lohikang pagbubuo gaya ng\nmanu-manong laro. Ang bawat\nkalalabasan ay natukoy nang\nhiwalay at sapalaran sa oras ng\npaghiwa.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text10.anchor.set(0.5)
                text10.position.set(-20, 1930);

                const text11 = new PIXI.Text('Kapag ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text11.anchor.set(0.5)
                text11.position.set(-300, 2230);

                const text12 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text12.anchor.set(0.5)
                text12.position.set(-40, 2230);

                const text13 = new PIXI.Text('ay gumana,', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text13.anchor.set(0.5)
                text13.position.set(230, 2230);

                const text14 = new PIXI.Text('ang laro ay awtomatikong\nmagpapatuloy sa susunod na hiwa\nng walang kailangang ambag ng\nmanlalaro', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text14.anchor.set(0.5)
                text14.position.set(-20, 2370);

                const text15 = new PIXI.Text('Ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text15.anchor.set(0.5)
                text15.position.set(-380, 2570);

                const text16 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text16.anchor.set(0.5)
                text16.position.set(-200, 2570);

                const text17 = new PIXI.Text('ay gumagamit ng', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text17.anchor.set(0.5)
                text17.position.set(135, 2570);

                const text18 = new PIXI.Text('kasalukuyang ayos ng pustahan', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text18.anchor.set(0.5)
                text18.position.set(-50, 2625);

                const text19 = new PIXI.Text('na aktibo nang ang AUTOPLAY ay\npinasimulan.Ang ganitong settings\nay nanatiling hindi nagbabago sa\npanahon ng pagpapatakbo ng\nAUTOPLAY maliban kung manu-\nmanong binago o pinahinto ng\nmanlalaro.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text19.anchor.set(0.5)
                text19.position.set(-15, 2855);

                const text20 = new PIXI.Text('Ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text20.anchor.set(0.5)
                text20.position.set(-373, 3130);

                const text21 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text21.anchor.set(0.5)
                text21.position.set(-193, 3130);

                const text22 = new PIXI.Text('ay magtatapos kung', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text22.anchor.set(0.5)
                text22.position.set(180, 3130);

                const text23 = new PIXI.Text('ang manlalaro ay manu-manong\nihihinto ang AUTOPLAY.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text23.anchor.set(0.5)
                text23.position.set(-40, 3210);

                const text24 = new PIXI.Text('Ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text24.anchor.set(0.5)
                text24.position.set(-373, 3350);

                const text25 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text25.anchor.set(0.5)
                text25.position.set(-193, 3350);

                const text26 = new PIXI.Text('ay kinakailangang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text26.anchor.set(0.5)
                text26.position.set(150, 3350);

                const text27 = new PIXI.Text('maihinto bago matapos ang huling\npaghiwa upang matagumpay na\nmapigilan ang automatikong pag-\numpisa ng susunod na paghiwa.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text27.anchor.set(0.5)
                text27.position.set(-10, 3490);

                childrenToAdd.push(text7, text8, text9, text10, text11, text12, text13, text14, text15, text16, text17, text18, text19, text20, text21, text22, text23, text24, text25, text26, text27);

                const text28 = new PIXI.Text('Mabilisang Mode', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: 60,
                    fontWeight: "600",
                    align: "left",
                });
                text28.anchor.set(0.5)
                text28.position.set(0, 3760);
                childrenToAdd.push(text28);

                const img7 = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
                img7.anchor.set(0.5);
                img7.scale.set(1.15);
                img7.position.set(0, 3915);
                childrenToAdd.push(img7)

                const text29 = new PIXI.Text('Ang pagpindot sa', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text29.anchor.set(0.5)
                text29.position.set(-210, 4070);

                const text30 = new PIXI.Text('Mabilisang Mode', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text30.anchor.set(0.5)
                text30.position.set(205, 4070);

                const text31 = new PIXI.Text('(TURBO Mode)', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text31.anchor.set(0.5)
                text31.position.set(-245, 4125);

                const text32 = new PIXI.Text('ay nagpapa andar', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text32.anchor.set(0.5)
                text32.position.set(145, 4125);

                const text33 = new PIXI.Text('sa autoplay mode at nagpapabilis\nng paglalaro', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text33.anchor.set(0.5)
                text33.position.set(-20, 4205);

                const text34 = new PIXI.Text('Kapag naka enable ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 57.6
                });
                text34.anchor.set(0.5)
                text34.position.set(-151, 4325);

                const text35 = new PIXI.Text('TURBO MODE', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 42 : 45,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 54
                });
                text35.anchor.set(0.5)
                text35.position.set(275, 4325);

                const text36 = new PIXI.Text('ay mas bumibilis ang takbo ng laro\nkapag nalalaktawan ang ilang\nanimasyon sa panalo (Win animation)\nat tunog nito.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 45 : 48,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 56.4
                });
                text36.anchor.set(0.5)
                text36.position.set(17, 4460);

                childrenToAdd.push(text29, text30, text31, text32, text33, text34, text35, text36);

            }
            this.tagPage11Container.addChild(...childrenToAdd);
        }

        this.applytagalogDragging()

        {
            const text1 = new PIXI.Text('Na Diskonekta o\nDi Natuloy na Laro', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
                lineHeight: 78
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const text2 = new PIXI.Text('Kung ang manlalaro ay madiskonekta habang\nsiya ay naglalaro, ang laro susubukang ikonekta\nng sistema upang automatikong maka konek\nmuli. Kung sakali ang manlalaro ay di maka \nkonek sa loob ng resonableng takdang oras,ang \nkatayuan ng laro ay mananatili at sosolusyunan\nna ayon sa mga alituntunin ng Fair play at \npagbawi ng laro ayon sa protokol. Ang mga\napektadong manlalaro ay maaring abisuhan at\nmaaring maibalik o matumbasan ang kabayaran \ndepende sa sitwasyon.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 40,
                fontWeight: "600",
                align: "left",
                lineHeight: isAppleMobileDevice() ? 45.6 : 48,
            });
            text2.anchor.set(0.5)
            text2.position.set(0, 35);

            const text3 = new PIXI.Text('Maaring sumangguni sa mga tuntunin sa\nng aming', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 40,
                fontWeight: "600",
                align: "left",
                lineHeight: isAppleMobileDevice() ? 45.6 : 48,
            });
            text3.anchor.set(0.5)
            text3.position.set(-75, 390);

            const text4 = new PIXI.Text('Patakaran ng Fair Play at mga', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 40,
                fontWeight: "600",
                align: "left",
                lineHeight: isAppleMobileDevice() ? 45.6 : 48,
            });
            text4.anchor.set(0.5)
            text4.position.set(10, 420);

            const text5 = new PIXI.Text('kondisyon', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 40,
                fontWeight: "600",
                align: "left",
                lineHeight: isAppleMobileDevice() ? 45.6 : 48,
            });
            text5.anchor.set(0.5)
            text5.position.set(-375, 460);

            const text6 = new PIXI.Text('para sa karagdagan pang detalye.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 40,
                fontWeight: "600",
                align: "left",
                lineHeight: isAppleMobileDevice() ? 45.6 : 48,
            });
            text6.anchor.set(0.5)
            text6.position.set(65, 460);

            this.tagPage12Container.addChild(text1, text2, text3, text4, text5, text6)
        }

        this.tagPage1Container.visible = true;
        this.tagPage2Container.visible = false;
        this.tagPage3Container.visible = false;
        this.tagPage4Container.visible = false;
        this.tagPage5Container.visible = false;
        this.tagPage6Container.visible = false;
        this.tagPage7Container.visible = false;
        this.tagPage8Container.visible = false;
        this.tagPage9Container.visible = false;
        this.tagPage10Container.visible = false;
        this.tagPage11Container.visible = false;
        this.tagPage12Container.visible = false;

        this.tagalogTutorialContainer.addChild(this.tagPage1Container, this.tagPage2Container, this.tagPage3Container, this.tagPage4Container, this.tagPage5Container, this.tagPage6Container, this.tagPage7Container, this.tagPage8Container, this.tagPage9Container, this.tagPage10Container, this.tagPage11Container, this.tagPage12Container)
    }

    applytagalogDragging() {
        this.tagPage11Container.interactive = fruitData.showAutoAndTurbo;
        this.tagPage11Container.cursor = fruitData.showAutoAndTurbo ? 'grab' : 'default';

        let dragging = false;
        let startY = 0;
        let containerStartY = 0;

        const MIN_Y = -3300;  // how far up the container can go
        const MAX_Y = 0;     // how far down (usually 0 = starting pos)

        this.tagPage11Container
            .on('pointerdown', (event) => {
                if (!fruitData.showAutoAndTurbo) return;
                dragging = true;
                startY = event.data.global.y;
                containerStartY = this.tagPage11Container.y;
            })
            .on('pointermove', (event) => {
                if (!dragging || !fruitData.showAutoAndTurbo) return;

                const currentY = event.data.global.y;
                const delta = currentY - startY;

                let newY = containerStartY + delta;

                if (newY < MIN_Y) newY = MIN_Y;
                if (newY > MAX_Y) newY = MAX_Y;

                this.tagPage11Container.y = newY;



                if (this.language == 'tag' && this.tagPage11Container.y > -3545) {
                    this.arrow.visible = true;
                }

                this.engScroll = false;
                this.tagScroll = false;
            })
            .on('pointerup', () => {
                dragging = false;
            })
            .on('pointerupoutside', () => {
                dragging = false;
            });

        this.tagPage5Container.interactive = true;
        this.tagPage5Container.cursor = 'grab';

        let dragging1 = false;
        let startY1 = 0;
        let containerStartY1 = 0;

        const MIN_Y1 = -670;  // how far up the container can go
        const MAX_Y1 = 0;     // how far down (usually 0 = starting pos)

        this.tagPage5Container
            .on('pointerdown', (event) => {
                dragging1 = true;
                startY1 = event.data.global.y;
                containerStartY1 = this.tagPage5Container.y;
            })
            .on('pointermove', (event) => {
                if (!dragging1) return;

                const currentY = event.data.global.y;
                const delta = currentY - startY1;

                let newY = containerStartY1 + delta;

                if (newY < MIN_Y1) newY = MIN_Y1;
                if (newY > MAX_Y1) newY = MAX_Y1;

                this.tagPage5Container.y = newY;
                this.tagScroll = false;
                this.arrow.visible = true;

            })
            .on('pointerup', () => {
                dragging1 = false;
            })
            .on('pointerupoutside', () => {
                dragging1 = false;
            });
    }

    applyDragging() {
        this.engPage11Container.interactive = fruitData.showAutoAndTurbo;
        this.engPage11Container.cursor = fruitData.showAutoAndTurbo ? 'grab' : 'default';

        let dragging = false;
        let startY = 0;
        let containerStartY = 0;

        const MIN_Y = -4035;  // how far up the container can go
        const MAX_Y = 0;     // how far down (usually 0 = starting pos)

        this.engPage11Container
            .on('pointerdown', (event) => {
                if (!fruitData.showAutoAndTurbo) return;
                dragging = true;
                startY = event.data.global.y;
                containerStartY = this.engPage11Container.y;
            })
            .on('pointermove', (event) => {
                if (!dragging || !fruitData.showAutoAndTurbo) return;

                const currentY = event.data.global.y;
                const delta = currentY - startY;

                let newY = containerStartY + delta;

                if (newY < MIN_Y) newY = MIN_Y;
                if (newY > MAX_Y) newY = MAX_Y;

                this.engPage11Container.y = newY;

                // console.log("thiss", );


                if (this.language == 'eng' && this.pointer == 10) { // Assuming pointer 10 is page 11
                    if (fruitData.showAutoAndTurbo && this.engPage11Container.y > -3545) { // Original condition for visibility
                        this.arrow.visible = true;
                    } else {
                        this.arrow.visible = false;
                    }
                }

                this.engScroll = false;
            })
            .on('pointerup', () => {
                dragging = false;
            })
            .on('pointerupoutside', () => {
                dragging = false;
            });

    }

    showTutorial(lang) {
        if (lang == 'eng') {
            this.language = 'eng'
            this.tagalogTutorialContainer.visible = false;
            this.englishTutorialContainer.visible = true;
        } else {
            this.language = 'tag'

            this.englishTutorialContainer.visible = false;
            this.tagalogTutorialContainer.visible = true;
        }
    }


    drawStartingPages(data, style1, style2) {
        this.engPage1Container = new PIXI.Container();
        this.engPage2Container = new PIXI.Container();
        this.engPage3Container = new PIXI.Container();
        this.engPage4Container = new PIXI.Container();
        this.engPage5Container = new PIXI.Container();
        this.engPage6Container = new PIXI.Container();
        this.engPage7Container = new PIXI.Container();
        this.engPage8Container = new PIXI.Container();
        this.engPage9Container = new PIXI.Container();
        this.engPage10Container = new PIXI.Container();
        this.engPage11Container = new PIXI.Container();
        this.engPage12Container = new PIXI.Container();

        for (let i = 1; i <= 12; i++) {
            this.englishPages.push(this[`engPage${i}Container`]);
        }

        {

            const text1 = new PIXI.Text(data.page1.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P1'));
            img1.anchor.set(0.5);
            img1.position.set(0, -15)

            const text2 = new PIXI.Text(data.page1.body.p1, style1);
            text2.anchor.set(0.5)
            text2.position.set(-85, 235)

            const text3 = new PIXI.Text(data.page1.body.p2, style2);
            text3.anchor.set(0.5)
            text3.position.set(240, 235);

            const text4 = new PIXI.Text(data.page1.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(-335, 350);

            const text5 = new PIXI.Text(data.page1.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "800",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(35, 350);

            const text6a = new PIXI.Text(data.page1.description.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text6a.anchor.set(0.5)
            text6a.position.set(375, 350);

            const text6b = new PIXI.Text(data.page1.description.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text6b.anchor.set(0.5)
            text6b.position.set(0, 415);

            const text6c = new PIXI.Text(data.page1.description.p3c, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text6c.anchor.set(0.5)
            text6c.position.set(-95, 480);

            const text7 = new PIXI.Text(data.page1.description.p4, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "800",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(125, 480);
            this.engPage1Container.addChild(text1, img1, text2, text3, text4, text5, text6a, text6b, text6c, text7);
        }

        {
            const text1 = new PIXI.Text(data.page2.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P2'));
            img1.anchor.set(0.5);
            img1.position.set(0, -15);

            const text2 = new PIXI.Text(data.page2.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-350, 245)

            const text3 = new PIXI.Text(data.page2.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "800",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(-217, 245)

            const text4 = new PIXI.Text(data.page2.description.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(130, 245)

            const text5 = new PIXI.Text(data.page2.description.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(-350, 310)

            const text6 = new PIXI.Text(data.page2.description.p4a, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "800",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(55, 310)

            const text7 = new PIXI.Text(data.page2.description.p4b, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "800",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(-245, 375)

            const text8 = new PIXI.Text(data.page2.description.p5a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(97, 375)

            const text9 = new PIXI.Text(data.page2.description.p5b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5)
            text9.position.set(0, 440)

            this.engPage2Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9)
        }

        {
            const text1 = new PIXI.Text(data.page3.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P3_A'));
            img1.anchor.set(0.5);
            img1.position.set(0, -150);

            const text2 = new PIXI.Text(data.page3.body, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            })
            text2.anchor.set(0.5);
            text2.position.set(0, -45);

            const img2 = new PIXI.Sprite(PIXI.Assets.get('EN_P3_B'));
            img2.anchor.set(0.5);
            img2.position.set(0, 95);

            const text3 = new PIXI.Text(data.page3.description.p1a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text3.anchor.set(0.5);
            text3.position.set(0, 210);

            const text4 = new PIXI.Text(data.page3.description.p1b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text4.anchor.set(0.5);
            text4.position.set(-330, 275);

            const text5 = new PIXI.Text(data.page3.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text5.anchor.set(0.5);
            text5.position.set(-45, 275);

            const text6 = new PIXI.Text(data.page3.description.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text6.anchor.set(0.5);
            text6.position.set(290, 275);

            const text7 = new PIXI.Text(data.page3.description.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text7.anchor.set(0.5);
            text7.position.set(-105, 340);

            const text8 = new PIXI.Text(data.page3.description.p4a, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text8.anchor.set(0.5);
            text8.position.set(300, 340);

            const text9 = new PIXI.Text(data.page3.description.p4b, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text9.anchor.set(0.5);
            text9.position.set(-200, 405);

            const text10 = new PIXI.Text(data.page3.description.p5a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text10.anchor.set(0.5);
            text10.position.set(135, 405);

            const text11 = new PIXI.Text(data.page3.description.p5b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text11.anchor.set(0.5);
            text11.position.set(0, 470);

            this.engPage3Container.addChild(text1, img1, text2, img2, text3, text4, text5, text6, text7, text8, text9, text10, text11)
        }

        {
            const text1 = new PIXI.Text(data.page4.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P4'));
            img1.anchor.set(0.5);
            img1.position.set(0, -45);

            const text2 = new PIXI.Text(data.page4.body.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text2.anchor.set(0.5);
            text2.position.set(-300, 195);

            const text3 = new PIXI.Text(data.page4.body.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text3.anchor.set(0.5);
            text3.position.set(166, 195);

            const text4 = new PIXI.Text(data.page4.body.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text4.anchor.set(0.5);
            text4.position.set(460, 195);

            const text5 = new PIXI.Text(data.page4.body.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text5.anchor.set(0.5);
            text5.position.set(-325, 260);

            const text6 = new PIXI.Text(data.page4.body.p4, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text6.anchor.set(0.5);
            text6.position.set(-110, 260);

            const text7 = new PIXI.Text(data.page4.body.p5a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text7.anchor.set(0.5);
            text7.position.set(215, 260);

            const text8 = new PIXI.Text(data.page4.body.p5b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text8.anchor.set(0.5);
            text8.position.set(-80, 325);

            const text9 = new PIXI.Text(data.page4.body.p5c, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text9.anchor.set(0.5);
            text9.position.set(90, 325);

            const text10 = new PIXI.Text(data.page4.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text10.anchor.set(0.5);
            text10.position.set(-385, 440);

            const text11 = new PIXI.Text(data.page4.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text11.anchor.set(0.5);
            text11.position.set(60, 440);

            const text12 = new PIXI.Text(data.page4.description.p3, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text12.anchor.set(0.5);
            text12.position.set(-340, 490);

            const text13 = new PIXI.Text(data.page4.description.p4, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text13.anchor.set(0.5);
            text13.position.set(-70, 490);

            const text14 = new PIXI.Text(data.page4.description.p5, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            })
            text14.anchor.set(0.5);
            text14.position.set(270, 490);


            this.engPage4Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11, text12, text13, text14)

        }

        {
            const text1 = new PIXI.Text(data.page5.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -370);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P5'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(270, 55);

            const text2 = new PIXI.Text(data.page5.sub_header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            })
            text2.anchor.set(0.5);
            text2.position.set(-140, -155);

            const text6 = new PIXI.Text('Each successful slice\nprogresses the player\nfurther up the prize\nmeter.', {
                fill: "#00FF00",
                fontFamily: "notoSans",
                fontSize: 38,
                fontWeight: "600",
                align: "left",
                lineHeight: 45
            })
            text6.anchor.set(0.5);
            text6.position.set(-173, 60);

            const text7 = new PIXI.Text('Your Current \nPrize is shown at\nthe base of the\nprize meter', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 38,
                fontWeight: "600",
                align: "left",
                lineHeight: 45
            })
            text7.anchor.set(0.5);
            text7.position.set(-220, 260);

            const text8 = new PIXI.Text('Track your progress toward\nwinning prizes.\nMore successful slices\nincrease your potential prize.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 36,
                fontWeight: "600",
                align: "left",
                lineHeight: 42
            })
            text8.anchor.set(0.5);
            text8.position.set(-120, 450);

            this.engPage5Container.addChild(text1, img1, text2, text6, text7, text8)
        }

        {
            const text1 = new PIXI.Text(data.page6.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P6'));
            img1.anchor.set(0.5);
            img1.position.set(0, 0);

            const text2 = new PIXI.Text(data.page6.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(0, 270);

            const text3 = new PIXI.Text(data.page6.description.p2, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(0, 335);

            this.engPage6Container.addChild(text1, img1, text2, text3)
        }

        {
            const text1 = new PIXI.Text(data.page7.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P7'));
            img1.anchor.set(0.5);
            img1.position.set(0, 30);

            const text2 = new PIXI.Text(data.page7.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(-265, 335);

            const text3 = new PIXI.Text(data.page7.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(20, 335);

            const text4 = new PIXI.Text(data.page7.description.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(295, 335);

            const text5 = new PIXI.Text(data.page7.description.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(10, 400);

            const text6 = new PIXI.Text(data.page7.description.p3c, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(10, 465);

            this.engPage7Container.addChild(text1, img1, text2, text3, text4, text5, text6)
        }

        {
            const text1 = new PIXI.Text(data.page8.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P8'));
            img1.anchor.set(0.5);
            img1.position.set(0, 10);

            const text2 = new PIXI.Text(data.page8.description.p1, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(-340, 320);

            const text3 = new PIXI.Text(data.page8.description.p2, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(-190, 320);

            const text4 = new PIXI.Text(data.page8.description.p3, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(35, 320);

            const text5 = new PIXI.Text(data.page8.description.p4, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(335, 320);

            const text6 = new PIXI.Text(data.page8.description.p5, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(-310, 385);

            const text7 = new PIXI.Text(data.page8.description.p6a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5);
            text7.position.set(90, 385);

            const text8 = new PIXI.Text(data.page8.description.p6b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5);
            text8.position.set(-200, 445);

            const text9 = new PIXI.Text(data.page8.description.p7, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5);
            text9.position.set(10, 445);

            const text10 = new PIXI.Text(data.page8.description.p8, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5);
            text10.position.set(170, 445);

            this.engPage8Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10)

        }

        {
            const text1 = new PIXI.Text(data.page9.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P9'));
            img1.anchor.set(0.5);
            img1.position.set(0, -90);

            const text2 = new PIXI.Text(data.page9.description.p1, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(-315, 85);

            const text3 = new PIXI.Text(data.page9.description.p2a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(140, 85);

            const text4 = new PIXI.Text(data.page9.description.p2b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(-300, 150);

            const text5 = new PIXI.Text(data.page9.description.p3, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(100, 150);

            const text6 = new PIXI.Text(data.page9.description.p4, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(0, 215);

            const text7 = new PIXI.Text(data.page9.description.p5, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5);
            text7.position.set(-155, 280);

            const text8 = new PIXI.Text(data.page9.description.p6, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5);
            text8.position.set(305, 280);

            const text9 = new PIXI.Text(data.page9.description.p7, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5);
            text9.position.set(0, 345);

            const text10 = new PIXI.Text(data.page9.description.p8a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5);
            text10.position.set(0, 410);

            const text11 = new PIXI.Text(data.page9.description.p8b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 49 : 52,
                fontWeight: "600",
                align: "center",
            });
            text11.anchor.set(0.5);
            text11.position.set(0, 475);

            this.engPage9Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11)
        }

        {
            const text1 = new PIXI.Text(data.page10.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P12'));
            img1.anchor.set(0.5);
            img1.position.set(0, 100);

            const text2 = new PIXI.Text(data.page10.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(0, 205);

            const text3 = new PIXI.Text(data.page10.description.p2, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(0, 265);

            const text4 = new PIXI.Text(data.page10.description.p3, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(0, 320);

            const text5 = new PIXI.Text(data.page10.description.p4, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(0, 375);

            const text6 = new PIXI.Text(data.page10.description.p5, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(0, 430);

            this.engPage10Container.addChild(text1, img1, text2, text3, text4, text5, text6)
        }

        {
            const childrenToAdd = [];

            const text1 = new PIXI.Text(data.page11.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 75,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -330);
            childrenToAdd.push(text1);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_A'));
            img1.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img1.scale.set(1);
                img1.position.set(-300, -120);
            } else {
                img1.scale.set(0.55);
                img1.position.set(-300, -180);
            }
            childrenToAdd.push(img1);

            const text2 = new PIXI.Text(data.page11.description1.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 52,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(0, fruitData.showAutoAndTurbo ? -125 : -180);
            childrenToAdd.push(text2);

            if (fruitData.showAutoAndTurbo) {
                const img2 = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
                img2.anchor.set(0.5);
                img2.scale.set(1);
                img2.position.set(-300, 70);
                childrenToAdd.push(img2);

                const text3 = new PIXI.Text(data.page11.description1.p2a, {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 40,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 48
                });
                text3.anchor.set(0.5);
                text3.position.set(20, 45);
                childrenToAdd.push(text3);

                const text4 = new PIXI.Text(data.page11.description1.p2b, {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 40,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 48
                });
                text4.anchor.set(0.5);
                text4.position.set(-70, 90);
                childrenToAdd.push(text4);

                const img3 = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
                img3.anchor.set(0.5);
                img3.position.set(-300, 250);
                childrenToAdd.push(img3);

                const text5 = new PIXI.Text(data.page11.description1.p3, {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 40,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 48
                });
                text5.anchor.set(0.5);
                text5.position.set(-11, 225);
                childrenToAdd.push(text5);

                const text6 = new PIXI.Text(data.page11.description1.p2b, {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 40,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 48
                });
                text6.anchor.set(0.5);
                text6.position.set(-72, 265);
                childrenToAdd.push(text6);
            }

            const img4 = new PIXI.Sprite(PIXI.Assets.get('menuNormal'));
            img4.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img4.position.set(-300, 405);
            } else {
                img4.scale.set(0.85)
                img4.position.set(-300, -20);
            }
            childrenToAdd.push(img4);

            const text7 = new PIXI.Text(data.page11.description1.p4a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 40,
                fontWeight: "600",
                align: "center",
                lineHeight: 48
            });
            text7.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                text7.position.set(55, 390);
            } else {
                text7.position.set(55, -35);
            }
            childrenToAdd.push(text7);

            const text8 = new PIXI.Text(data.page11.description1.p4b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 40,
                fontWeight: "600",
                align: "center",
                lineHeight: 48
            });
            text8.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                text8.position.set(-35, 425);
            } else {
                text8.position.set(-35, 3);
            }
            childrenToAdd.push(text8);

            const img5 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_b'));
            img5.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img5.scale.set(1);
                img5.position.set(45, 665);
            } else {
                img5.scale.set(0.8);
                img5.position.set(-110, 180);
            }
            childrenToAdd.push(img5);

            const imgText1 = new PIXI.Text(' Change\n Bet/Slices', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "600",
                align: "left",
                lineHeight: 60
            });
            imgText1.anchor.set(0.5);
            imgText1.position.set(140, 10);
            img5.addChild(imgText1)

            const img6 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_c'));
            img6.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img6.scale.set(1);
                img6.position.set(-190, 1065);
            } else {
                img6.scale.set(0.6);
                img6.position.set(-290, 420);
            }
            childrenToAdd.push(img6);

            const imgText2 = new PIXI.Text('  Easy\nAccess\nOption', {
                fill: "#60004C",
                fontFamily: "notoSans",
                fontSize: 44,
                fontWeight: "600",
                align: "left",
                lineHeight: 52.8
            });
            imgText2.anchor.set(0.5);
            imgText2.position.set(0, -100);
            img6.addChild(imgText2)

            const text11 = new PIXI.Text(' Change\n Bet/Slices by\n tapping the\n center.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 45,
                fontWeight: "600",
                align: "left",
                lineHeight: 54
            });
            text11.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                text11.position.set(205, 980);
                text11.scale.set(1);
            } else {
                text11.position.set(25, 400);
                text11.scale.set(0.8);
            }
            childrenToAdd.push(text11);

            if (fruitData.showAutoAndTurbo) {
                const text12 = new PIXI.Text('Autoplay', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: 75,
                    fontWeight: "900",
                    align: "center",
                });
                text12.anchor.set(0.5);
                text12.position.set(0, 1375);
                childrenToAdd.push(text12);

                const autoImg = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
                autoImg.anchor.set(0.5);
                autoImg.scale.set(1.1)
                autoImg.position.set(0, 1505)
                childrenToAdd.push(autoImg);

                const text13 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text13.anchor.set(0.5);
                text13.position.set(-265, 1615);
                childrenToAdd.push(text13);

                const text14 = new PIXI.Text('automatically initiates', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 60
                });
                text14.anchor.set(0.5);
                text14.position.set(150, 1615);
                childrenToAdd.push(text14);

                const text15 = new PIXI.Text('each slice using the same random\nnumber generation logic as\nmanual play. Each outcome is\ndetermined independently and\nrandomly at the time of the slice.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text15.anchor.set(0.5);
                text15.position.set(20, 1790);
                childrenToAdd.push(text15);

                const text16 = new PIXI.Text('When', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text16.anchor.set(0.5);
                text16.position.set(-315, 2060);
                childrenToAdd.push(text16);

                const text17 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text17.anchor.set(0.5);
                text17.position.set(-105, 2060);
                childrenToAdd.push(text17);

                const text18 = new PIXI.Text('is enabled, the', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text18.anchor.set(0.5);
                text18.position.set(215, 2060);
                childrenToAdd.push(text18);

                const text19 = new PIXI.Text('game will automatically continue\nto the next slice without requiring\nplayer input.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                })
                text19.anchor.set(0.5);
                text19.position.set(35, 2175);
                childrenToAdd.push(text19);

                const text20 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text20.anchor.set(0.5);
                text20.position.set(-260, 2370);
                childrenToAdd.push(text20);

                const text21 = new PIXI.Text('uses the', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text21.anchor.set(0.5);
                text21.position.set(-15, 2370);
                childrenToAdd.push(text21);

                const text22 = new PIXI.Text('current bet', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text22.anchor.set(0.5);
                text22.position.set(240, 2370);
                childrenToAdd.push(text22);

                const text23 = new PIXI.Text('configuration', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text23.anchor.set(0.5);
                text23.position.set(-225, 2420);
                childrenToAdd.push(text23);

                const text24 = new PIXI.Text('that was active', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text24.anchor.set(0.5);
                text24.position.set(140, 2420);
                childrenToAdd.push(text24);

                const text25 = new PIXI.Text('when AUTOPLAY was initiated.\nThese settings remain constant\nfor the duration of the AUTOPLAY\nsession unless manually changed\nby the player or interrupted.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text25.anchor.set(0.5);
                text25.position.set(20, 2595);
                childrenToAdd.push(text25);

                const text26 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text26.anchor.set(0.5);
                text26.position.set(-260, 2880);
                childrenToAdd.push(text26);

                const text27 = new PIXI.Text('end when the player', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text27.anchor.set(0.5);
                text27.position.set(130, 2880);
                childrenToAdd.push(text27);

                const text28 = new PIXI.Text('manually stops AUTOPLAY.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text28.anchor.set(0.5);
                text28.position.set(-70, 2935);
                childrenToAdd.push(text28);

                const text29 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text29.anchor.set(0.5);
                text29.position.set(-260, 3080);
                childrenToAdd.push(text29);

                const text30 = new PIXI.Text('must be disabled before', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 43 : 46,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 55
                });
                text30.anchor.set(0.5);
                text30.position.set(155, 3080);
                childrenToAdd.push(text30);

                const text31 = new PIXI.Text('the final slice has ended to\nsuccessfully stop the next game\nfrom automatically starting.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text31.anchor.set(0.5);
                text31.position.set(0, 3195);
                childrenToAdd.push(text31);

                const text32 = new PIXI.Text('Turbo Mode', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: 75,
                    fontWeight: "900",
                    align: "center",
                    lineHeight: 90
                });
                text32.anchor.set(0.5);
                text32.position.set(0, 3390);
                childrenToAdd.push(text32);

                const turboImg = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
                turboImg.anchor.set(0.5);
                turboImg.scale.set(1.1)
                turboImg.position.set(0, 3515);
                childrenToAdd.push(turboImg);

                const text33 = new PIXI.Text('Pressing the', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text33.anchor.set(0.5);
                text33.position.set(-225, 3640);
                childrenToAdd.push(text33);

                const text34 = new PIXI.Text('TURBO', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text34.anchor.set(0.5);
                text34.position.set(25, 3640);
                childrenToAdd.push(text34);

                const text35 = new PIXI.Text('button', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text35.anchor.set(0.5);
                text35.position.set(210, 3640);
                childrenToAdd.push(text35);

                const text36 = new PIXI.Text('activates the autoplay mode and\nspeeds up the game.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text36.anchor.set(0.5);
                text36.position.set(25, 3725);
                childrenToAdd.push(text36);

                const text37 = new PIXI.Text('When', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text37.anchor.set(0.5);
                text37.position.set(-300, 3890);
                childrenToAdd.push(text37);

                const text38 = new PIXI.Text('TURBO MODE', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text38.anchor.set(0.5);
                text38.position.set(-45, 3890);
                childrenToAdd.push(text38);

                const text39 = new PIXI.Text('is enabled', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text39.anchor.set(0.5);
                text39.position.set(260, 3890);
                childrenToAdd.push(text39);

                const text40 = new PIXI.Text('some win animations and sounds\nare skipped, and the game moves\nfaster.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 47 : 50,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 60
                });
                text40.anchor.set(0.5);
                text40.position.set(40, 4005);
                childrenToAdd.push(text40);
            }

            this.engPage11Container.addChild(...childrenToAdd);
        }

        {
            const text1 = new PIXI.Text(data.page12.header1, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 60,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -355);

            const text2 = new PIXI.Text(data.page12.header2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 60,
                fontWeight: "900",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(0, -285);

            const text3 = new PIXI.Text(data.page12.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(0, -210);

            const text4 = new PIXI.Text(data.page12.description.p2, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(-15, -160);

            const text5 = new PIXI.Text(data.page12.description.p3, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(-63, -110);

            const text6 = new PIXI.Text(data.page12.description.p4, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(-13, -60);

            const text7 = new PIXI.Text(data.page12.description.p5, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5);
            text7.position.set(-75, -10);

            const text8 = new PIXI.Text(data.page12.description.p6, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5);
            text8.position.set(-10, 40);

            const text9 = new PIXI.Text(data.page12.description.p7, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5);
            text9.position.set(-70, 90);

            const text10 = new PIXI.Text(data.page12.description.p8, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5);
            text10.position.set(-2, 140);

            const text11 = new PIXI.Text(data.page12.description.p9, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text11.anchor.set(0.5);
            text11.position.set(-58, 190);

            const text12 = new PIXI.Text(data.page12.description.p10, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text12.anchor.set(0.5);
            text12.position.set(-20, 240);

            const text13 = new PIXI.Text(data.page12.description.p11, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text13.anchor.set(0.5);
            text13.position.set(-40, 290);

            const text14 = new PIXI.Text(data.page12.description.p12, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text14.anchor.set(0.5);
            text14.position.set(-110, 340);

            const text15 = new PIXI.Text(data.page12.description.p13, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text15.anchor.set(0.5);
            text15.position.set(-152, 425);

            const text16 = new PIXI.Text(data.page12.description.p14, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text16.anchor.set(0.5);
            text16.position.set(125, 425);

            const text17 = new PIXI.Text(data.page12.description.p15, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text17.anchor.set(0.5);
            text17.position.set(-45, 470);

            const text18 = new PIXI.Text(data.page12.description.p16, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text18.anchor.set(0.5);
            text18.position.set(-154, 515);

            this.engPage12Container.addChild(text1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11, text12, text13, text14, text15, text16, text17, text18)
        }

        this.applyDragging()

        this.engPage1Container.visible = true;
        this.engPage2Container.visible = false;
        this.engPage3Container.visible = false;
        this.engPage4Container.visible = false;
        this.engPage5Container.visible = false;
        this.engPage6Container.visible = false;
        this.engPage7Container.visible = false;
        this.engPage8Container.visible = false;
        this.engPage9Container.visible = false;
        this.engPage10Container.visible = false;
        this.engPage11Container.visible = false;
        this.engPage12Container.visible = false;

        this.englishTutorialContainer.addChild(this.engPage1Container, this.engPage2Container, this.engPage3Container, this.engPage4Container, this.engPage5Container, this.engPage6Container, this.engPage7Container, this.engPage8Container, this.engPage9Container, this.engPage10Container, this.engPage11Container, this.engPage12Container)
    }

    setupTutorialMask() {
        this.maskGraphic = new PIXI.Graphics();
        this.maskGraphic.beginFill(0xFFFFFF);
        this.maskGraphic.drawRect(-478, -410, 955, 945);
        this.maskGraphic.endFill();

        this.maskTutGraphic = new PIXI.Graphics();
        this.maskTutGraphic.beginFill(0xFFFFFF);
        this.maskTutGraphic.drawRect(-478, -410, 955, 945);
        this.maskTutGraphic.endFill();

        this.tutorialMenuActive.addChild(this.maskGraphic)
    }

    setupSettingsContent() {
        const musicButton = new PIXI.Sprite(PIXI.Assets.get('music_b_normal'));
        musicButton.anchor.set(0.5);
        musicButton.x = 0;
        musicButton.y = -210;
        musicButton.interactive = true;
        musicButton.cursor = 'pointer';

        const musicHover = new PIXI.Sprite(PIXI.Assets.get('music_b_selected'));
        musicHover.anchor.set(0.5);
        musicHover.visible = false;

        const musicDisable = new PIXI.Sprite(PIXI.Assets.get('music_b_disabled'));
        musicDisable.anchor.set(0.5);
        musicDisable.visible = false;

        musicButton.addChild(musicHover, musicDisable);

        musicButton.on('pointerover', () => {
            musicHover.visible = true;
        })

        musicButton.on('pointerout', () => {
            musicHover.visible = false;
        })

        musicButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

                musicDisable.visible = !musicDisable.visible;

                if (musicDisable.visible) {
                    this.currentSound = getCurrentlyPlayingBg();
                    playMainBg(false);
                    playMainBg1(false);
                    playMainBg2(false);
                    sfxSound.bg = false;
                    clearInterval(gameAssets.ambientTimeout);
                    playAmbient(false);
                } else {
                    sfxSound.bg = true;
                    if (this.currentSound == 'mainBg') playMainBg(true);
                    else if (this.currentSound == 'mainBg1') playMainBg1(true);
                    else playMainBg2(true);

                    scheduleAmbient()

                }
            }
        })

        const soundButton = new PIXI.Sprite(PIXI.Assets.get('sound_b_normal'));
        soundButton.anchor.set(0.5);
        soundButton.x = -280;
        soundButton.y = -210;
        soundButton.interactive = true;
        soundButton.cursor = 'pointer';

        const soundHover = new PIXI.Sprite(PIXI.Assets.get('sound_b_selected'));
        soundHover.anchor.set(0.5);
        soundHover.visible = false;

        const soundDisable = new PIXI.Sprite(PIXI.Assets.get('sound_b_disabled'));
        soundDisable.anchor.set(0.5);
        soundDisable.visible = false;

        soundButton.on('pointerover', () => {
            soundHover.visible = true;
        })

        soundButton.on('pointerout', () => {
            soundHover.visible = false;
        })

        soundButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                soundDisable.visible = !soundDisable.visible
                if (soundDisable.visible) {
                    toggleNonBgSounds(false)
                } else {
                    toggleNonBgSounds(true)
                }

            }
        })

        soundButton.addChild(soundHover, soundDisable);

        //Vibrate Button
        const vibrateButton = new PIXI.Sprite(PIXI.Assets.get('vibrate_b_normal'));
        vibrateButton.anchor.set(0.5);
        vibrateButton.x = 280;
        vibrateButton.y = -210;
        vibrateButton.interactive = true;
        vibrateButton.cursor = 'pointer';

        const vibrateHover = new PIXI.Sprite(PIXI.Assets.get('vibrate_b_selected'));
        vibrateHover.anchor.set(0.5);
        vibrateHover.visible = false;

        const vibrateDisable = new PIXI.Sprite(PIXI.Assets.get('vibrate_b_disabled'));
        vibrateDisable.anchor.set(0.5);
        vibrateDisable.visible = false;

        vibrateButton.on('pointerover', () => {
            vibrateHover.visible = true;
        })

        vibrateButton.on('pointerout', () => {
            vibrateHover.visible = false;
        })

        vibrateButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (vibrateDisable.visible) {
                    vibrateDisable.visible = false
                    fruitData.vibration = true
                } else {
                    vibrateDisable.visible = true
                    fruitData.vibration = false;
                }
            }
        })

        vibrateButton.addChild(vibrateHover, vibrateDisable);

        //Languages
        const languageText = new PIXI.Sprite(PIXI.Assets.get('lang'))
        languageText.anchor.set(0.5);
        languageText.scale.set(1.1);
        languageText.x = 0;
        languageText.y = -15;


        //VERSION NUMBER
        const buildText = new PIXI.Text('Version Number ' + '1.0.0', {
            fill: '#FFC800',
            fontSize: 53,
            fontFamily: 'Arial',
            align: 'center',
            fontWeight: 'bold'
        })
        buildText.anchor.set(0.5);
        buildText.x = 0;
        buildText.y = 530;
        buildText.scale.set(0.6)

        this.settingsMenuActive.addChild(musicButton, soundButton, vibrateButton, languageText, buildText);
    }

    setupCloseButton() {
        this.closeButtonNormal = new PIXI.Sprite(PIXI.Assets.get('close_b_normal'));
        this.closeButtonNormal.anchor.set(0.5);
        this.closeButtonNormal.scale.set(1.2);
        this.closeButtonNormal.position.set(1285, 360);
        this.closeButtonNormal.interactive = true;
        this.closeButtonNormal.cursor = 'pointer'
        this.backgroundBlur.addChild(this.closeButtonNormal);

        const closeButtonHover = new PIXI.Sprite(PIXI.Assets.get('close_b_selected'));
        closeButtonHover.anchor.set(0.5);
        closeButtonHover.visible = false;
        this.closeButtonNormal.addChild(closeButtonHover);

        this.closeButtonNormal.on('pointerover', () => {
            closeButtonHover.visible = true;
        })

        this.closeButtonNormal.on('pointerout', () => {
            closeButtonHover.visible = false;
        })

        this.closeButtonNormal.on('pointerdown', () => {
            closeButtonHover.visible = false;
            this.disable();
            this.engScroll = false;
        })
    }

    setupMenu() {
        this.settingsMenuActive = new PIXI.Sprite(PIXI.Assets.get('menu_settings'));
        this.settingsMenuActive.anchor.set(0.5);
        this.settingsMenuActive.scale.set(1.25);
        this.settingsMenuActive.x = config.logicalWidth / 2
        this.settingsMenuActive.y = config.logicalHeight / 2
        this.backgroundBlur.addChild(this.settingsMenuActive);

        this.tutorialMenuActive = new PIXI.Sprite(PIXI.Assets.get('menu_tutorial'));
        this.tutorialMenuActive.anchor.set(0.5);
        this.tutorialMenuActive.scale.set(1.25);
        this.tutorialMenuActive.x = config.logicalWidth / 2
        this.tutorialMenuActive.y = config.logicalHeight / 2
        this.backgroundBlur.addChild(this.tutorialMenuActive);

        this.betHistoryActive = new PIXI.Sprite(PIXI.Assets.get('menu_history'));
        this.betHistoryActive.anchor.set(0.5);
        this.betHistoryActive.visible = false;
        this.betHistoryActive.scale.set(1.25);
        this.betHistoryActive.x = config.logicalWidth / 2
        this.betHistoryActive.y = config.logicalHeight / 2
        this.backgroundBlur.addChild(this.betHistoryActive);

        this.settingsButton = new PIXI.Graphics();
        this.settingsButton.beginFill(0, 0.01);
        this.settingsButton.drawRect(config.logicalWidth / 2 - 620, config.logicalHeight / 2 - 710, 350, 110);
        this.settingsButton.endFill();
        this.settingsButton.interactive = true;
        this.settingsButton.cursor = 'pointer'
        this.settingsButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                this.enableSettingsMenu()
            }
        });
        this.backgroundBlur.addChild(this.settingsButton);

        this.tutorialButton = new PIXI.Graphics();
        this.tutorialButton.beginFill(0, 0.01);
        this.tutorialButton.drawRect(config.logicalWidth / 2 - 175, config.logicalHeight / 2 - 710, 350, 110);
        this.tutorialButton.endFill();
        this.tutorialButton.interactive = true;
        this.tutorialButton.cursor = 'pointer'
        this.tutorialButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') { this.enableTutorialMenu() }
        });
        this.backgroundBlur.addChild(this.tutorialButton);

        this.betHistoryButton = new PIXI.Graphics();
        this.betHistoryButton.beginFill(0, 0.01);
        this.betHistoryButton.drawRect(config.logicalWidth / 2 + 260, config.logicalHeight / 2 - 710, 355, 110);
        this.betHistoryButton.endFill();
        this.betHistoryButton.interactive = true;
        this.betHistoryButton.cursor = 'pointer'
        this.betHistoryButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') { this.enableBetHistory() }
        });
        this.backgroundBlur.addChild(this.betHistoryButton);
    }

    enableBetHistory() {
        playTabChange(true);
        this.betArrow1.visible = true;
        this.betArrow2.visible = true;
        this.betArrow3.visible = true;
        this.leftScroll = this.rightScroll = this.verticalScroll = false;

        this.settingsMenuActive.visible = false;
        this.tutorialMenuActive.visible = false;
        this.betHistoryActive.visible = true;
        this.settingsButton.interactive = true;
        this.tutorialButton.interactive = true;
        this.betHistoryButton.interactive = false;
        betHistory()
    }

    enableSettingsMenu() {
        this.settingsMenuActive.visible = true;
        this.tutorialMenuActive.visible = false;
        this.betHistoryActive.visible = false;
        this.settingsButton.interactive = false;
        this.tutorialButton.interactive = true;
        this.betHistoryButton.interactive = true;
        playTabChange(true)
    }

    enableTutorialMenu() {
        this.settingsMenuActive.visible = false;
        this.tutorialMenuActive.visible = true;
        this.betHistoryActive.visible = false;
        playTabChange(true)
        this.settingsButton.interactive = true;
        this.tutorialButton.interactive = false;
        this.betHistoryButton.interactive = true;
    }

    enable() {
        // fruitData.play = false;
        gameAssets.fruit1.visible = gameAssets.fruit2.visible = gameAssets.fruit3.visible = gameAssets.fruit4.visible = false;
        gameAssets.gameUI.visible = false;
        this.menuPopUp.visible = true;

        this.settingsButton.interactive = false;
        this.tutorialButton.interactive = true;
        this.betHistoryButton.interactive = true;
    }

    disable() {
        this.menuPopUp.visible = false;
        gameAssets.gameUI.visible = true;
        playPopupClose(true);
        gameAssets.menubarButton.alpha = 1;
        gameAssets.menubarButton.tint = 0xffffff
        gameAssets.menubarButton.interactive = true;

        this.settingsMenuActive.visible = true;
        this.tutorialMenuActive.visible = false;
        this.betHistoryActive.visible = false;

        this.betArrow1.visible = true;
        this.betArrow2.visible = true;
        this.betArrow3.visible = true;
        this.leftScroll = this.rightScroll = this.verticalScroll = false;

        if (this.language == 'eng') {
            this.pointer = 0;
            this.tagPage11Container.y = this.engPage11Container.y = 0;

            this.englishPages.map((value, index) => {
                if (index == 0) value.visible = true;
                else value.visible = false;
            })
            this.updateTutorialIndicator()
            this.arrow.visible = false;
        } else {
            this.pointer = 0;
            this.tagPage11Container.y = this.engPage11Container.y = 0;

            this.tagalogPages.map((value, index) => {
                if (index == 0) value.visible = true;
                else value.visible = false;
            })
            this.updateTutorialIndicator()
            this.arrow.visible = false;
        }

        gameAssets.fruit1.visible = gameAssets.fruit2.visible = gameAssets.fruit3.visible = gameAssets.fruit4.visible = true;
        // fruitData.play = true;
        // launchFruit('fruit1');
        // launchFruit('fruit2', true)
        // instances.JackpotPanel.jackpotPanelSprite.visible = true
        //   console.log('popUp closed')
    }
}